'use strict';

var jsxRuntime = require('react/jsx-runtime');

const WishketFacebook = ({ testId, className })=>{
    return jsxRuntime.jsx("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        "data-testid": testId,
        className: className,
        children: jsxRuntime.jsx("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M9.382 14V8.07001H11.372L11.67 5.75901H9.382V4.28401C9.382 3.61401 9.568 3.15801 10.527 3.15801H11.752V1.09001C11.1591 1.0277 10.5632 0.997653 9.967 1.00001C8.204 1.00001 6.995 2.07701 6.995 4.05401V5.76001H5V8.07001H6.995V14H9.382Z",
            fill: "#9E9E9E"
        })
    });
};

module.exports = WishketFacebook;
